<svelte:head>
  <title>Edit | {data?.name || "Offer"} | A Good Thing</title>
</svelte:head>

<h2 class="title">Edit offer</h2>

{#if data}
  <OfferEditor {data} isValid={true} />
{/if}

<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <button
      class="button is-primary"
      class:is-loading={isLoadingSave}
      on:click={() => update()}>Save</button
    >
  </div>
</div>

{#if errorMessage}
  <div class="notification is-danger is-light">{errorMessage}</div>
{/if}

<script lang="ts">
  import _ from "lodash";
  import { logging } from '../../../../lib/logging';
  import { goto, params } from "@sveltech/routify";
  import OfferEditor from "../../../business/_components/OfferEditor.svelte";

  let id: string = $params["id"];

  let data: Offer_v2;

  let errorMessage: string;
  let isLoadingSave = false;

  let firebase = window.firebase;

  get();

  async function get() {
    data = await firebase
      .firestore()
      .collection("offers_v2")
      .doc(id)
      .get()
      .then((doc) => doc.data() as Offer_v2);
  }

  async function update() {
    isLoadingSave = true;

    await firebase
      .firestore()
      .collection("offers_v2")
      .doc(id)
      .set(data)
      .then(() => {
        if( data.status == 'published' || data.status == 'ended' ) {
          return firebase
          .functions()
          .httpsCallable('api-offer-updatepublishedoffer')({ id } as UpdatePublishedOfferParams); 
        }
      })
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => {
        isLoadingSave = false;
      });

    $goto("../index");
  }
</script>
